const helpers = {
    applyStyles: (clientStyles) => {
        for(var key in clientStyles){
            let value = clientStyles[key]
            if (key === 'background' && value) {
                const stringValue = String(value)
                if (stringValue.indexOf('url(') === -1 && stringValue.indexOf('gradient(') === -1) {
                    value = 'url("' + stringValue + '")'
                }
            }
            if (key === 'secondaryBtnBorder' && value) {
                const stringValue = String(value).trim()
                if (stringValue.indexOf('solid') === -1) {
                    value = '1px solid ' + stringValue
                }
            }
            document.documentElement.style.setProperty('--'+key, value);
        }
    }
}

export default helpers
